module.exports = __webpack_public_path__ + "static/flags/CT-288f6db73e9a447a9a2f18de53f57277.gif";